import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function PaymentCancelPage() {
  useEffect(() => {
    document.title = "Checkout Cancelled · Pickle Wall™";
    trackEvent("checkout_abandoned", { page_path: "/payment/cancel" });
  }, []);
  return (
    <main id="main-content" className="bg-[#0a0a0a] text-white min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-lg glass rounded-3xl p-10 text-center" data-testid="payment-cancel-page">
        <XCircle size={56} className="text-white/40 mx-auto" />
        <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tight">
          Checkout Cancelled
        </h1>
        <p className="mt-3 text-white/60">
          No worries — nothing was charged. Your cart is still waiting whenever
          you&apos;re ready.
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link
            to="/shop"
            data-testid="cancel-return-shop"
            className="inline-flex items-center bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-sm px-6 py-3"
          >
            Return to Shop
          </Link>
          <Link
            to="/"
            className="inline-flex items-center glass text-white font-bold uppercase tracking-wider text-sm px-6 py-3"
          >
            Home
          </Link>
        </div>
      </div>
    </main>
  );
}
